export const sliceArray = (arr: any[], start?: number, end?: number): any[] => {
  return arr.length ? arr.slice(start, end) : [];
};